import { Country } from "../Country.js";
import { EconomicSubjectVatType } from "../EconomicSubjectVatType.js";
import { isCountryInEuropeanUnion } from "./isCountryInEuropeanUnion.js";

export function shouldApplyOSS(destinationCountry: Country | "outsideEu", vatType: EconomicSubjectVatType): boolean {
	return (
		vatType === EconomicSubjectVatType.NotVatSubject &&
		isCountryInEuropeanUnion(destinationCountry) &&
		destinationCountry !== Country.Czechia
	);
}
